import { IFinancialStatementInterpretation, NumberFormats, Signs } from '@modeso/types__aumico-lib-annualreport-be';

export const defaultSystemRules: IFinancialStatementInterpretation = {
    numberFormat: NumberFormats.SINGLE,
    assets: Signs.POSITIVE,
    liabilities: Signs.POSITIVE,
    income: Signs.POSITIVE,
    expenses: Signs.NEGATIVE,
};
